import React from 'react'
import { Helmet } from 'react-helmet'
import langs, { __ } from '../langs'

import Header from '../layout/header'
export default () => {
  return (
    <>
      <Helmet title="About" />
      <Header />
      <div className="section">
        <div className="sectionInner blog">
          <h1> {langs.terms.title}</h1>
          <div
            dangerouslySetInnerHTML={{ __html: __(langs.terms.description) }}
          />
        </div>
      </div>
    </>
  )
}
